import { helpItems } from '@/components/HelpCenterBtn/config';
import RegularText from '@/components/RegularText';
import { Button, Modal, Text } from '@shopify/polaris';
import { QuestionCircleIcon } from '@shopify/polaris-icons';
import { useState, useMemo } from 'react';

const HelpCenterBtn = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const onClose = () => {
    setIsOpen(false);
    setCurrentPage(0); // Reset về trang đầu khi đóng modal
  };

  // Tính toán các trang từ helpItems (mỗi trang 2 phần tử)
  const pages = useMemo(() => {
    const itemsPerPage = 2;
    const totalPages = Math.ceil(helpItems.length / itemsPerPage);
    const pagesArray = [];

    for (let i = 0; i < totalPages; i++) {
      const startIndex = i * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      pagesArray.push(helpItems.slice(startIndex, endIndex));
    }

    return pagesArray;
  }, []);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={'Help center'}
      activator={
        <Button icon={QuestionCircleIcon} onClick={() => setIsOpen(true)}>
          Help center
        </Button>
      }
      footer={
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '8px',
          }}
          id="help-center-footer"
        >
          <Button
            onClick={() => {
              try {
                $crisp.push(['do', 'chat:open']);
              } catch (error) {
                console.log(error);
              }
            }}
          >
            Contact support
          </Button>
          <Button onClick={onClose} variant="primary">
            Done
          </Button>
        </div>
      }
    >
      <Modal.Section>
        <div
          id="help-center-content"
          style={{
            overflow: 'hidden',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: `${pages.length * 100}%`,
              transform: `translateX(-${currentPage * (100 / pages.length)}%)`,
              transition: 'transform 0.4s ease-in-out',
            }}
          >
            {pages.map((pageItems, pageIndex) => (
              <div
                key={pageIndex}
                className="d-flex"
                style={{
                  width: `${100 / pages.length}%`,
                  flexShrink: 0,
                  gap: '16px',
                  padding: '0 8px',
                  boxSizing: 'border-box',
                }}
              >
                {pageItems.map((item) => (
                  <div
                    className="d-flex flex-column gap-4 help-center-card"
                    key={item.id}
                    style={{
                      flex: 1,
                      minWidth: 0,
                      maxWidth: `calc(50% - 8px)`,
                    }}
                  >
                    <div className="d-flex flex-column gap-4">
                      <Text variant="headingSm" as="strong">
                        {item.title}
                      </Text>
                      <RegularText>{item.content}</RegularText>
                    </div>
                    <div className="mt-8">
                      <Button onClick={item.onClick}>{item.button}</Button>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div id="help-center-content-footer">
          <div className="navigate-btn">
            {pages.map((_, index) => (
              <div
                className="navigate-btn-point"
                style={{
                  backgroundColor: currentPage === index ? '#464646' : '#e2e2e2',
                }}
                key={index}
                onClick={() => setCurrentPage(index)}
              ></div>
            ))}
          </div>
        </div>
      </Modal.Section>
    </Modal>
  );
};

export default HelpCenterBtn;
